function removeSignatureFromBody(body) {
  const bodySplit = body.split("\n");
  return bodySplit[0].startsWith("*") && bodySplit[0].endsWith(":*")
    ? bodySplit.slice(1).join("\n")
    : body;
}

export default removeSignatureFromBody;